<template>
        <div class="instructions" :class="{ active: ui.helpVisible }" @click.stop>
            <div class="wrapper">
                <a href="#" @click.prevent.stop="ui.toggleHelp" class="help-button">
                    <span class="sub-title" v-html="ui.t('instructions')"></span>
                    <span class="title" v-html="ui.t(titleKey)"></span>
                </a>
            </div>

            <div class="content">
                <div class="wrapper">
                    <a href="#" class="close" @click.prevent.stop="ui.toggleHelp">
                        <span class="icon-close"></span>
                    </a>
                </div>

                <div class="items">
                    <div class="wrapper">
                        <div v-for="help in ui.blocks[property]" :key="help" class="col-4">
                            <info-display :content="help" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>

<script async setup lang="ts">
import { useUI } from '../store';


const { 
    titleKey = "",
    property = ""
 } = defineProps<{ 
    titleKey: string,
    property: string
 }>();

const { ui } = useUI();

</script>
